import { Component, OnInit } from '@angular/core';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaValidateService } from '../../../formly/ga-validate.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../formly/ga-formly.service';
import { WorkflowDataService } from '../../../services/workflow/workflow-data.service';
import { GaEventService } from '../../../services/ga-event.service';

@Component({
  selector: 'close-order-pending-action',
  templateUrl: '../../../message/dialogs/default-form-dialog.html'
})
export class CloseOrderPendingActionComponent extends BaseReportActionsDialog implements OnInit {
  private pendingField: IExtraFieldConfigurationObject;

  constructor(
    private formlyService: GaFormlyService,
    private workflowDataService: WorkflowDataService,
    eventService: GaEventService,
    validateService: GaValidateService
  ) {
    super(eventService, validateService);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    // init model
    this.model = {
      stepDefId: undefined,
      comment: undefined,
      sendMail: true
    };

    // create fields
    this.fields = this.createFields();

    // fill fields
    this.fillFields();
  }

  private createFields(): IExtraFieldConfigurationObject[] {
    return [
      this.pendingField = this.formlyService.aSelect('stepDefId', 'Pending')
        .isRequired()
        .withLabelProp('value')
        .withValueProp('id')
        .build(),
      this.formlyService.aTextarea('comments', 'Comments')
        .build(),
      this.formlyService.aCheckbox('sendMail', 'Send mail for this update')
        .withoutWrapper()
        .build()
    ];
  }

  private fillFields(): void {
    const workflowType: string = this.workflowDataService.getWorkflowType(this.rowSelection, this.action);
    this.formlyService.fillField(this.pendingField, this.workflowDataService.loadWorkflowStepDefinitions(workflowType, 'PENDING'));
  }
}